/* ===== ETERNALLÉ — CARRITO DRAWER =====
   Expone window.EtCart = { open, close, render, refreshCount }.
   Textos, colores, complementos y empuje al pack se editan en la sección "Carrito". */
(function () {
  'use strict';

function boot() {
  var root = document.getElementById('CartDrawer');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('CartDrawerConfig').textContent); } catch (e) {}

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    overlay: $('CartDrawerOverlay'), close: $('CartDrawerClose'), body: $('CartDrawerBody'),
    foot: $('CartDrawerFooter'), count: $('CartDrawerCount'), headerCount: $('CartCount'),
    ship: $('CdShip'), shipMsg: $('CdShipMsg'), shipFill: $('CdShipFill'),
    nudge: $('CdNudge'), nudgeBtn: $('CdNudgeBtn'), upsell: $('CdUpsell'),
    discountRow: $('CdDiscountRow'), discount: $('CdDiscount'), total: $('CdTotal'), checkoutTotal: $('CdCheckoutTotal'),
    care: $('CdCare'), careInput: $('CdCareInput'), empty: $('CdEmpty'), featAdd: $('CdFeatAdd')
  };
  var careVid = Number(cfg.protectionVariantId) || 0;
  var carePid = Number(cfg.protectionProductId) || 0;
  var currency = 'MXN';
  var lastCart = null;

  function money(cents) {
    var locale = currency === 'MXN' ? 'es-MX' : 'es-ES';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); });
  }

  /* ---------- abrir / cerrar ---------- */
  function open() {
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return render();
  }
  function close() {
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  els.overlay && els.overlay.addEventListener('click', close);
  els.close && els.close.addEventListener('click', close);

  /* ---------- protección de envío (Care+) ----------
     Su línea nunca se lista ni cuenta como producto: solo marca la casilla. */
  function isCare(item) { return careVid && (item.variant_id === careVid || item.product_id === carePid); }
  function isGift(item) { return !isCare(item) && item.final_line_price === 0; }
  function split(cart) {
    var care = cart.items.filter(isCare);
    var items = cart.items.filter(function (i) { return !isCare(i); });
    var view = Object.assign({}, cart, {
      items: items,
      item_count: items.reduce(function (n, i) { return n + i.quantity; }, 0),
      goods_total: cart.total_price - care.reduce(function (n, i) { return n + i.final_line_price; }, 0)
    });
    return { view: view, care: care };
  }

  /* ---------- pintar ---------- */
  function updateBadges(count) {
    if (els.headerCount) els.headerCount.textContent = count;
    if (els.count) els.count.textContent = count;
  }

  function renderShipping(cart) {
    if (!els.ship) return;
    var threshold = currency === 'MXN' ? cfg.shipThresholdMXN : cfg.shipThresholdOther;
    threshold = Number(threshold) || 0;
    var left = threshold - cart.goods_total;
    els.ship.hidden = false;
    if (left <= 0) {
      els.shipMsg.textContent = cfg.shipDone || '';
      els.shipFill.style.width = '100%';
    } else {
      els.shipMsg.textContent = (cfg.shipLeft || '').replace('[amount]', money(left));
      els.shipFill.style.width = Math.max(4, Math.min(100, Math.round(cart.goods_total / threshold * 100))) + '%';
    }
  }

  function lineHTML(item) {
    var original = item.original_line_price, final = item.final_line_price;
    var pct = original > final ? Math.round((original - final) / original * 100) : 0;
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(esc(item.variant_title));
    if (item.selling_plan_allocation) meta.push(esc(item.selling_plan_allocation.selling_plan.name));
    if (item.properties) Object.keys(item.properties).forEach(function (k) {
      if (k.charAt(0) !== '_' && item.properties[k]) meta.push(esc(k) + ': ' + esc(item.properties[k]));
    });
    var img = item.image || '';
    return '' +
      '<div class="cd__item" data-key="' + esc(item.key) + '">' +
        '<div class="cd__item-img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</div>' +
        '<div>' +
          '<p class="cd__item-title">' + esc(item.product_title) + '</p>' +
          (meta.length ? '<p class="cd__item-meta">' + meta.join('<br>') + '</p>' : '') +
          '<div class="cd__qty">' +
            '<button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="Añadir uno">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd__item-side">' +
          '<button type="button" class="cd__remove" data-qty="0" aria-label="Eliminar">' +
            '<svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24"><path d="M4 7h16M9 7V4h6v3m-8 0l1 13h8l1-13"/></svg>' +
          '</button>' +
          (pct > 0 ? '<span class="cd__pill">' + esc((cfg.savePill || '').replace('[percent]', pct)) + '</span>' : '') +
          '<p class="cd__price">' + money(final) + (pct > 0 ? '<s>' + money(original) + '</s>' : '') + '</p>' +
        '</div>' +
      '</div>';
  }

  function giftHTML(item) {
    var img = item.image || '';
    return '<div class="cd__gift">' +
      '<div class="cd__gift-img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=100" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="cd__gift-info"><p class="cd__gift-name">' + (item.quantity > 1 ? item.quantity + '× ' : '') + esc(item.product_title) + '</p>' +
      '<p class="cd__gift-price">' + esc(cfg.giftLabel || 'GRATIS') + (item.original_line_price > 0 ? ' <s>' + money(item.original_line_price) + '</s>' : '') + '</p></div>' +
    '</div>';
  }

  function itemsHTML(cart) {
    var paid = cart.items.filter(function (i) { return !isGift(i); });
    var gifts = cart.items.filter(isGift);
    var ups = upgradeKeys(cart);
    var html = paid.map(function (i) {
      var h = lineHTML(i);
      return ups[i.key] ? h.replace(/<\/div>$/, upgradeHTML(i.key, ups[i.key]) + '</div>') : h;
    }).join('');
    if (gifts.length) {
      html += '<div class="cd__gifts"><p class="cd__gifts-title">' + esc(cfg.giftsTitle || '') + '</p>' +
        '<div class="cd__gifts-row">' + gifts.map(giftHTML).join('') + '</div></div>';
    }
    return html;
  }

  // Casilla "pásate al pack completo" debajo de cada producto elegible (una por producto).
  var bundleIds = String(cfg.bundleProductIds || '').split(',').filter(Boolean).map(Number);
  var bundleQty = Number(cfg.bundleQty) || 3;
  function upgradeKeys(cart) {
    var map = {};
    if (!cfg.bundleEnable || !bundleIds.length) return map;
    bundleIds.forEach(function (pid) {
      var lines = cart.items.filter(function (i) { return !isGift(i) && i.product_id === pid; });
      if (!lines.length) return;
      var total = lines.reduce(function (n, i) { return n + i.quantity; }, 0);
      if (total < bundleQty) map[lines[0].key] = lines[0].quantity + (bundleQty - total);
    });
    return map;
  }
  function upgradeHTML(key, qty) {
    return '<label class="cd__up3"><input type="checkbox" data-up3-key="' + esc(key) + '" data-up3-qty="' + qty + '">' +
      '<span class="cd__up3-box" aria-hidden="true"><svg viewBox="0 0 12 12" width="12" height="12"><path d="M2.5 6.2l2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span>' + esc((cfg.upText || '').replace('[qty]', bundleQty)) + '</span>' +
      (cfg.upBadge ? '<span class="cd__up3-badge">' + esc(cfg.upBadge) + '</span>' : '') +
    '</label>';
  }

  function renderUpsell(cart) {
    if (!els.upsell) return;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var shown = 0;
    els.upsell.querySelectorAll('.cd__up').forEach(function (u) {
      var hide = inCart.indexOf(Number(u.dataset.productId)) > -1;
      u.hidden = hide;
      if (!hide) shown++;
    });
    els.upsell.hidden = !(cart.item_count > 0 && shown > 0);
  }

  // Un regalo vale mientras algún producto pagado tenga al menos las unidades de su pack (_regalo, por defecto 2).
  function orphanGifts(full) {
    var perProduct = {};
    full.items.forEach(function (i) {
      if (isCare(i) || isGift(i)) return;
      perProduct[i.product_id] = (perProduct[i.product_id] || 0) + i.quantity;
    });
    var maxQty = Object.keys(perProduct).reduce(function (m, k) { return Math.max(m, perProduct[k]); }, 0);
    return full.items.filter(function (i) {
      if (!isGift(i)) return false;
      var min = Number(i.properties && i.properties._regalo) || 2;
      return maxQty < min;
    });
  }

  function paint(full) {
      var parts = split(full);
      var cart = parts.view;
      lastCart = full;
      currency = full.currency || currency;
      updateBadges(cart.item_count);

      // Si solo queda la protección (se quitó todo lo demás), se quita también.
      if (!cart.item_count && parts.care.length) {
        return api('/cart/update.js', { updates: careUpdates(parts.care, 0) }).then(paint);
      }
      // Regalos sin pack que los respalde (se quitó o bajó el producto): se retiran.
      var orphan = orphanGifts(full);
      if (orphan.length) {
        var ou = {};
        orphan.forEach(function (i) { ou[i.key] = 0; });
        return api('/cart/update.js', { updates: ou }).then(paint);
      }
      if (els.careInput) els.careInput.checked = parts.care.length > 0;

      if (els.empty) els.empty.hidden = cart.item_count > 0;
      if (!cart.item_count) {
        els.body.innerHTML = els.empty ? '' : '<div class="cd__empty"><p>' + esc(cfg.emptyText) + '</p><a href="' + esc(cfg.emptyUrl || '/collections/all') + '">' + esc(cfg.emptyLink) + '</a></div>';
        els.foot.hidden = true;
        // Con envío siempre gratis (umbral 0) la barra no aporta nada si no hay productos.
        if (els.ship) { var th = Number(currency === 'MXN' ? cfg.shipThresholdMXN : cfg.shipThresholdOther) || 0; if (th > 0) renderShipping(cart); else els.ship.hidden = true; }
        renderUpsell(cart);
        return cart;
      }

      renderShipping(cart);
      els.body.innerHTML = itemsHTML(cart);
      renderUpsell(cart);

      var discount = cart.total_discount || 0;
      els.discountRow.hidden = discount <= 0;
      els.discount.textContent = '−' + money(discount);
      els.total.textContent = money(cart.total_price);
      els.checkoutTotal.textContent = money(cart.total_price);
      els.foot.hidden = false;
      return cart;
  }

  function render() {
    return api('/cart.js').then(paint).catch(function (err) {
      console.error('Carrito:', err);
      els.body.innerHTML = '<div class="cd__empty"><p>No se pudo cargar el carrito. Recarga la página.</p></div>';
    });
  }

  function careUpdates(lines, qty) {
    var u = {};
    lines.forEach(function (l, i) { u[l.key] = i === 0 ? qty : 0; });
    return u;
  }

  // Las peticiones van en fila y cada una pinta con el carrito que devuelve Shopify (1 sola llamada).
  var queue = Promise.resolve(), pending = 0;
  function busy(on) {
    pending += on ? 1 : -1;
    root.classList.toggle('cd--loading', pending > 0);
  }
  function run(request) {
    busy(true);
    queue = queue.then(request).then(paint).catch(function (e) { alert(e.message); return render(); })
      .then(function (c) { busy(false); return c; });
    return queue;
  }
  function change(key, qty) {
    return run(function () { return api('/cart/change.js', { id: key, quantity: Math.max(0, qty) }); });
  }

  /* ---------- eventos ---------- */
  // +/− responden al instante; se envía la cantidad final cuando el cliente deja de pulsar.
  var timers = {};
  els.body.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-up3-key]');
    if (!cb || !cb.checked) return;
    cb.disabled = true;
    change(cb.dataset.up3Key, Number(cb.dataset.up3Qty));
  });

  els.body.addEventListener('click', function (e) {
    if (e.target.closest('.cd__up3')) return;
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var line = btn.closest('.cd__item');
    if (!line) return;
    var qty = Math.max(0, Number(btn.dataset.qty));
    var key = line.dataset.key;
    if (qty === 0) { line.classList.add('is-removing'); clearTimeout(timers[key]); change(key, 0); return; }
    var span = line.querySelector('.cd__qty span');
    span.textContent = qty;
    line.querySelectorAll('.cd__qty button')[0].dataset.qty = qty - 1;
    line.querySelectorAll('.cd__qty button')[1].dataset.qty = qty + 1;
    line.classList.add('is-pending');
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, qty); }, 350);
  });

  els.upsell && els.upsell.addEventListener('click', function (e) {
    var btn = e.target.closest('.cd__up-add');
    if (!btn) return;
    btn.disabled = true;
    var u = {}; u[btn.dataset.variantId] = 1;
    run(function () { return api('/cart/update.js', { updates: u }); }).then(function () { btn.disabled = false; });
  });

  els.featAdd && els.featAdd.addEventListener('click', function () {
    var b = els.featAdd;
    b.disabled = true;
    var u = {}; u[b.dataset.variantId] = 1;
    run(function () { return api('/cart/update.js', { updates: u }); }).then(function () { b.disabled = false; });
  });

  els.careInput && els.careInput.addEventListener('change', function () {
    var u = {}; u[careVid] = els.careInput.checked ? 1 : 0;
    run(function () { return api('/cart/update.js', { updates: u }); });
  });

  // El icono del carrito de la cabecera abre el drawer.
  var icon = document.querySelector('.cart-icon');
  icon && icon.addEventListener('click', function (e) { e.preventDefault(); open(); });

  window.EtCart = {
    open: open,
    close: close,
    render: render,
    refreshCount: function () { return api('/cart.js').then(function (c) { updateBadges(split(c).view.item_count); return c; }).catch(function () {}); }
  };
  window.openCartDrawer = function () { return window.EtCart.open(); };
  window.closeCartDrawer = function () { return window.EtCart.close(); };
  window.EtCart.isOpen = function () { return root.classList.contains('open'); };
}

  boot();

  // Eventos globales (una sola vez): siempre llaman a la instancia actual.
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && window.EtCart && window.EtCart.isOpen()) window.EtCart.close(); });
  document.addEventListener('cart:open', function () { window.EtCart && window.EtCart.open(); });
  document.addEventListener('cart:refresh', function () { window.EtCart && window.EtCart.render(); });

  // Personalizador: al editar la sección se vuelve a montar; al seleccionarla se abre.
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('#CartDrawer')) { boot(); window.EtCart.open(); } });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('#CartDrawer')) window.EtCart.open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector('#CartDrawer')) window.EtCart.close(); });
})();
